import React from 'react'

function BillPaymentLockTypes (props){

    let { setLockType } = props

    return (
        <div style={{ flexWrap:"wrap", display:"flex", justifyContent: "space-evenly", margin:"auto 0px"}}>
            <div
                className={["button", "onlyboarder", "normalText", "normalMediumSize"].join(" ")} 
                onClick={() => setLockType("client_document_number")} 
                style={{width:"40%", margin:"10px 0"}}
            >
                Documento do Cliente
            </div>
        </div>
    )
}

export default BillPaymentLockTypes